// Ensure 'subscribe' and 'publish' functions are available

if (!customElements.get('upsell-custom')) {
  customElements.define(
    'upsell-custom',
    class UpsellCustom extends HTMLElement {
      constructor() {
        super();
        this.queryParam = this.dataset.queryParam || 'add_product';
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.productId = this.dataset.productId; // Upsell product ID
      }

      connectedCallback() {
          this.container = this.querySelector('.upsell-custom');
          this.sellingPlanSubcriber = null;
          this.isInitialSellingPlan = this.dataset.isInitialSellingPlan === '';
          // 1. Synchronize with URL on load
          this.initialSelect();
          
          // 2. Add event listeners
          this.addEventListeners();

          // 3. Initial selling plan logic
          if (this.isInitialSellingPlan) {
            this.container.classList.add('hidden');
            this.checkbox.checked = false;
            this.updateUrl(false);
          }
          
          // 3. Subscription logic (left unchanged)
          this.sellingPlanSubcriber = subscribe(PUB_SUB_EVENTS.sellingPlanChange, (event) => {
            const isSellingPlanSelected = event.data.sellingPlanId !== '';

            if (isSellingPlanSelected) {
              // Hide the upsell section and uncheck if a subscription is selected
              this.container.classList.add('hidden')
              this.checkbox.checked = false;
              
              // Important: update the URL after the change caused by the subscription logic
              this.updateUrl(false); 

              // publish(PUB_SUB_EVENTS.removeImageFromGallerySlider, { ... });
            } else {
              this.container.classList.remove('hidden');
            }
          });
      }
      
      addEventListeners() {
           this.checkbox.addEventListener('change', (event) => {
            // 4. Update URL on click/change
            this.updateUrl(event.target.checked);
            
            // Your widget logic (visual/slider update)
            if (event.target.checked) {
              publish(PUB_SUB_EVENTS.addImageToGallerySlider, {
                blockId: this.dataset.blockId,
                imageUrl: this.dataset.sliderImage,
              });
            } else {
              publish(PUB_SUB_EVENTS.removeImageFromGallerySlider, {
                blockId: this.dataset.blockId,
                imageUrl: this.dataset.sliderImage,
              });
            }
          });
      }

      /**
       * Reads the URL parameter and checks/unchecks the checkbox.
       * Requires the URL parameter to be '1' (or product ID) if checked.
       */
      initialSelect() {
        const urlParams = new URLSearchParams(window.location.search);
        const urlValue = urlParams.get(this.queryParam);
        
        // Define what 'checked' means in the URL. We use product ID if available, or '1' as a flag.
        const checkValue = this.productId || '1';

        // If the URL value matches the check value OR is set to 'true'
        const isCheckedFromUrl = urlValue === checkValue || urlValue === 'true';

        if (isCheckedFromUrl) {
          this.checkbox.checked = true;
          
          // Trigger the visual/slider logic for the pre-selected option
          publish(PUB_SUB_EVENTS.addImageToGallerySlider, {
              blockId: this.dataset.blockId,
              imageUrl: this.dataset.sliderImage,
              isInitial: true,
          });
        } else {
           this.checkbox.checked = false;
        }
      }

      /**
       * Updates the URL parameter based on the checkbox state.
       * @param {boolean} isChecked - The state of the checkbox.
       */
      updateUrl(isChecked) {
        const url = new URL(window.location.href);
        
        // The value to set in the URL when checked (using ID or simple '1')
        const setValue = this.productId || '1';

        if (isChecked) {
          url.searchParams.set(this.queryParam, setValue);
        } else {
          url.searchParams.delete(this.queryParam);
        }

        window.history.replaceState({}, '', url.toString());
      }

      disconnectedCallback() {
        // Unsubscribe from events when the element is removed from the DOM
        if (this.sellingPlanSubcriber) {
          this.sellingPlanSubcriber.unsubscribe();
        }
      }
     
    }
  );
}
